import type { ReactElement } from "react";

export interface SetLocationEsriAttributionProps {
	label: string;
	className?: string;
}

/**
 * Figma `_Powered by Row` (148:8223) — Esri licensing attribution under
 * Geocode search results.
 */
export function SetLocationEsriAttribution({
	label,
	className,
}: SetLocationEsriAttributionProps): ReactElement {
	return (
		<div
			className={className ?? "flex w-full shrink-0 items-end pt-1"}
			data-testid="set-location-esri-attribution"
		>
			<p className="text-xs font-medium whitespace-nowrap text-secondary">
				{label}
			</p>
		</div>
	);
}
